import React from 'react';

import DevOpsContent from './productsPartials/DevOpsContenet';
import DevOpsBanner from './productsPartials/DevOpsBanner';

const DevOps = () => {
  return (
    <div className="container">
      <div className="main-beam padd">
        <DevOpsContent />
        <DevOpsBanner />
      </div>
    </div>
  );
};

export default DevOps;
